export default {
    red50: "#ffebee", red100: "#ffcdd2", red400: "#ef5350", red700: "#d32f2f",
    green50: "#e8f5e9", green100: "#dcedc8", green400: "#9ccc65", green700: "#689f38",
    blue50: "#e1f5fe", blue100: "#b3e5fc", blue400: "#29b6f6", blue700: "#0288d1",
    purple50: "#f3e5f5", purple100: "#e1bee7", purple400: "#ab47bc",  purple700: "#7b1fa2",
    orange50: "#fff3e0", orange100: "#ffe0b2", orange400: "#ffa726", orange700: "#f57c00",
    pink50: "#fce4ec", pink100: "#f8bbd0", pink400: "#ec407a", pink700: "#c2185b",
    yellow50: "#fffde7", yellow100: "#fff9c4", yellow400: "#ffee58", yellow500: "#ffeb3b", yellow700: "#fbc02d",
};